import { createSelector } from 'reselect';
import { StoreState } from '../store-interfaces';
import TriggerModel from '../model/TriggerModel';

const selectTriggers = (state: StoreState) => state.trigger.entities;

const getQAndATriggers = (triggers: TriggerModel[]): TriggerModel[] =>
  triggers.filter(trigger => !trigger.kind || trigger.kind === 'default');

const getInstagramAndFacebookTriggers = (
  triggers: TriggerModel[],
): TriggerModel[] =>
  triggers.filter(
    trigger =>
      trigger.kind === 'instagram_keywords' ||
      trigger.kind === 'facebook_keywords',
  );

const getSMSKeywordsTrigger = (triggers: TriggerModel[]) =>
  triggers.filter(trigger => trigger.kind === 'sms_keywords');

export const qAndATriggersSelector = createSelector(
  [selectTriggers],
  getQAndATriggers,
);

export const instagramAndFacebookTriggersSelector = createSelector(
  [selectTriggers],
  getInstagramAndFacebookTriggers,
);

export const smsKeywordsTriggersSelector = createSelector(
  [selectTriggers],
  getSMSKeywordsTrigger,
);
